import React from "react";
import {
  makeStyles,
  Box,
  Container,
  Grid,
  Typography,
  Button,
  IconButton,
} from "@material-ui/core";
import HistoryTable from "./HistoryTable";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Link } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  fieroBox: {
    position: "relative",
    zIndex: "9",
    padding: "50px 0",
    "& .fieropriceTextbox": {
      background: theme.palette.background.gradientbox,
      borderRadius: "31px",
      padding: "25px",
      [theme.breakpoints.down("xs")]: {
        padding: "12px",
      },
    },
    "& .grayText": {
      color: theme.palette.text.secondary,
    },
    "& img": {
      width: "auto",
      maxWidth: "100%",
      [theme.breakpoints.down("xs")]: {
        maxWidth: "15px",
      },
    },
    "& h2": {
      lineHeight: "60px",
    },
  },
  fierotableBox: {
    background: theme.palette.background.cardinner,
    borderRadius: "8px",
    padding: "10px",
    "& .inndergraphBox": {
      border: "1px solid rgba(255, 255, 255, 0.1)",
      borderRadius: "8px",
      padding: "15px",
      margin: "15px",
      [theme.breakpoints.down("xs")]: {
        margin: "0px",
      },
    },
  },
}));

function Fiero() {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.fieroBox}>
        <Box className="purplecircleBox"></Box>
        <Container maxWidth="lg">
          <Box className="gradientBorder">
            <Box className="fieropriceTextbox">
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} lg={5} sm={5} md={5}>
                  <AnimationOnScroll animateIn="animate__fadeInLeft">
                    <Typography variant="h3" color="primary">
                      Why FIERES?
                    </Typography>
                  </AnimationOnScroll>

                  <Box mt={2}>
                    <Typography variant="body2" className="grayText">
                      Welcome to the exciting new era of blockchain, where
                      people come together to create a more sustainable,
                      inclusive, and equitable world. At Fieres, we're proud to
                      be leading the way with our innovative Fieres Chain, which
                      bridges the physical and digital worlds, connecting
                      real-world data to digital assets.
                    </Typography>
                  </Box>
                  <Box mt={2}>
                    <Typography variant="body2" className="grayText">
                      Our vision is to create a world where transparency and
                      trust are fundamental, and technology is the key to
                      fostering this trust between individuals and
                      organisations. With Fieres Chain, we're making this vision
                      a reality by quantifying and validating actions and their
                      impacts. You can take ownership of your personal data,
                      control its use, and be part of a secure, trustworthy, and
                      transparent transfer of information and value. This is the
                      power of Web3 - where everyone is an owner and co-creator,
                      not just a user.
                    </Typography>
                    <Typography variant="body2" className="grayText">
                      Experience the future of digital asset creation with
                      Fieres Chain, designed for low transaction fees and
                      real-time execution. Our blockchain empowers financial
                      institutions and businesses with fast and reliable
                      transactions, while also enabling individuals to actively
                      participate in shaping more sustainable value chains. Join
                      us today and be part of the revolution!
                    </Typography>
                  </Box>
                  <Box mt={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      target="_blank"
                      href="https://fieroscan.com/"
                    >
                      Explorer
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={7} sm={7} md={7}>
                  <Box className={classes.fierotableBox}>
                    <Box className="inndergraphBox">
                      <HistoryTable />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default Fiero;
